import React from "react";
import { Box, RadioGroup, SxProps } from "@mui/material";
import { StyledFormControlLabel } from "./StyledFormControlLabel";
import { UIRadioButton } from "./UIRadioButton";
import { UICollapse } from "./UICollapse";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";
import { IBuildingBlockControl } from "./BuildingBlockInterfaces";
import { UILabel } from "./UILabel";

interface IRadioGroupItem {
    value: string;
    label?: string;
    renderUI?: () => JSX.Element | null;
}

interface IRadioGroupWithContent extends IBuildingBlockControl<string> {
    items: IRadioGroupItem[];
    error?: string;
    inputSx?: SxProps;
}

export function UIRadioGroup(props: IRadioGroupWithContent) {
    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            width={props.fullWidth ? "100%" : undefined}
            sx={props.sx}
        >
            {props.label && <UILabel>{props.label}</UILabel>}
            <RadioGroup
                value={props.value}
                onChange={(event: React.ChangeEvent<HTMLInputElement>, value: string) => props.onChange(value)}
                sx={{
                    border: props.error ? "1px solid " + UIStyleConstants.RED_COLOR : undefined,
                    borderRadius: "4px",
                    ...props.inputSx,
                }}
            >
                {props.items.map((item: IRadioGroupItem) => (
                    <div key={item.value}>
                        <StyledFormControlLabel
                            value={item.value}
                            control={<UIRadioButton />}
                            label={item.label || item.value}
                            data-testid={`radio-group-${item.value}`}
                        />
                        {item.renderUI && <UICollapse in={item.value === props.value}>{item.renderUI()}</UICollapse>}
                    </div>
                ))}
                {(props.hint || props.error) && (
                    <UILabel variant={props.error ? "error_hint" : "hint"}>{props.error ?? props.hint}</UILabel>
                )}
            </RadioGroup>
        </Box>
    );
}
